<template>
  <div
    v-if="pageInfo.totalPages > 1"
    class="pagination-wrapper no-print"
  >
    <button
      :disabled="!pageInfo.hasPreviousPage"
      @click="updateOffset(pageInfo.currentPage - 1)"
      class="button previous"
    >Previous</button>
    <p
      class="is-smaller"
      v-if="pageInfo.totalPages > 1"
    >Page {{pageInfo.currentPage}} of {{pageInfo.totalPages}}</p>
    <button
      :disabled="!pageInfo.hasNextPage"
      @click="updateOffset(pageInfo.currentPage + 1)"
      class="button next"
    >Next</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  methods: {
    updateOffset (number) {
      const { pageInfo } = this.$store.state.staff
      console.log('Pagination: ', pageInfo, number)
      this.$store.commit('staff/UPDATE_PAGEINFO', {
        ...pageInfo,
        currentPage: number
      })
      this.$store.commit('staff/UPDATE_OFFSET', number)
      const element = document.getElementById('staff-directory')
      if (element) {
        const offset = 130
        const bodyRect = document.body.getBoundingClientRect().top
        const elementRect = element.getBoundingClientRect().top
        const elementPosition = elementRect - bodyRect
        const offsetPosition = elementPosition - offset
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  },
  computed: {
    ...mapState('staff', ['pageInfo'])
  }
}
</script>
